'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from '../atoms/shadcn/button.js';
import { useGetIntl } from '@repo/i18n/intl/client';
import { cn } from '@repo/lib';
import { useSearchParams } from 'next/navigation';
import { SlMagnifier } from 'react-icons/sl';
import Form from 'next/form';

function Search({ className, dictionaryPromise, lang }) {
    const searchParams = useSearchParams();
    const intl = useGetIntl({
        dictionaryPromise,
        lang
    });
    const id = "search";
    // TODO: Check why this form is not submitting
    // TODO: Transition backdrop opacity and blur
    return /*#__PURE__*/ jsx("div", {
        className: cn("bg-transparent", "fixed inset-0", "transition-discrete transition-all duration-300 ease-in-out", "opacity-0 open:opacity-100 open:translate-x-0 starting:open:opacity-0", "backdrop:bg-background/25 backdrop:backdrop-blur-md", className),
        id: id,
        popover: "auto",
        children: /*#__PURE__*/ jsxs(Form, {
            action: "/search",
            className: "grid place-content-center",
            children: [
                /*#__PURE__*/ jsx("h2", {
                    className: "mb-2 text-lg uppercase",
                    children: intl.formatMessage({
                        defaultMessage: "Search the store",
                        id: "6tEVX+",
                        description: "Prompt for the user to carry out a search"
                    })
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ jsx("input", {
                            autoComplete: "off",
                            className: cn("py-2 px-4 border-inherit"),
                            defaultValue: (searchParams == null ? void 0 : searchParams.get("query")) || undefined,
                            name: "query",
                            placeholder: intl.formatMessage({
                                defaultMessage: "Search the store",
                                id: "6tEVX+",
                                description: "Prompt for the user to carry out a search"
                            }),
                            type: "search"
                        }),
                        /*#__PURE__*/ jsx(Button, {
                            "aria-label": intl.formatMessage({
                                defaultMessage: "Search the store",
                                id: "6tEVX+",
                                description: "Prompt for the user to carry out a search"
                            }),
                            className: "h-auto rounded-none",
                            popoverTarget: id,
                            popoverTargetAction: "hide",
                            variant: "default",
                            children: /*#__PURE__*/ jsx(SlMagnifier, {
                                className: "icon fill icon-size"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

export { Search };
